// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react' // eslint-disable-line no-unused-vars
import { connect } from 'react-redux'
import CallOut from '../callout/ev-callout'
import { FsCore } from '../../types/fs-core'
import { getErrors } from '../../redux/product-tables/product-table-selectors'

interface ProductTableErrorBlockProps {
  errors?: any[]
}
const ProductTableErrorBlock = ({ errors }: ProductTableErrorBlockProps) => {
  return (
    <If condition={errors && errors.length > 0}>
      <CallOut
        sx={{ marginBottom: 'md' }}
        icon='information'
        title='We are unable to connect to one of our eligibility partners'
        text='You’ll still see your chance of acceptance, but it might not be as accurate as it could be. You can continue to compare, or come back later to run a new eligibility check.'
      />
    </If>
  )
}
interface ConnectProductTableErrorBlockProps {
  datasetId: string
}
const ConnectProductTableErrorBlock = connect(
  (state: FsCore.State, props: ConnectProductTableErrorBlockProps) => {
    const errors = getErrors(state, props.datasetId)
    return { errors }
  },
)(ProductTableErrorBlock)

export default (props) => <ConnectProductTableErrorBlock {...props} />
